import client from './client'

export default {
  async getAlbumDetail (id) {
    const url = `/album/${id}`
    const res = await client.get(url)
    return res && res.data && res.data.data
  },
  async getAlbumVideos (id, params) {
    const res = await client.get(`/v2/album/${id}/videos`, {params: params})
    return res && res.data && res.data.data
  },
  async getRecommendAlbums (id) {
    const url = `/album/${id}/relatedAlbums`
    const res = await client.get(url)
    return res && res.data && res.data.data
  },
  async follow (id, params) {
    const url = `/album/${id}/follow`
    const res = await client.post(url, params)
    return res && res.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/album.js